module.exports = __webpack_public_path__ + "static/cosygiraffesteel-e138be3f80cbff71a1db4c0f277db794.jpeg";